import React from 'react';
import PropTypes from 'prop-types';
import { statusMeta, EMPTY_VALUE } from './status';

const PILL_CLASSES = {
    active: 'tw-text-st-active tw-bg-st-active-a12 tw-border-st-active-a28',
    passive: 'tw-text-st-passive tw-bg-st-passive-a12 tw-border-st-passive-a28',
    closed: 'tw-text-st-closed tw-bg-st-closed-a12 tw-border-st-closed-a28',
    unknown: 'tw-text-st-unknown tw-bg-st-unknown-a12 tw-border-st-unknown-a28',
};

const DOT_CLASSES = {
    active: 'tw-bg-st-active',
    passive: 'tw-bg-st-passive',
    closed: 'tw-bg-st-closed',
    unknown: 'tw-bg-st-unknown',
};

export default function StatusChip({ statusKey, locale, rawLabel }) {
    const raw = rawLabel && String(rawLabel).trim() ? String(rawLabel).trim() : '';
    const label = statusKey === 'unknown' ? raw : statusMeta(statusKey, locale).label;

    if (statusKey === 'unknown' && !raw) {
        return <span className="tw-text-muted tw-font-semibold">{EMPTY_VALUE}</span>;
    }

    return (
        <span
            aria-label={`Statusi: ${label}`}
            className={`tw-inline-flex tw-items-center tw-gap-1.5 tw-h-6 tw-pl-2 tw-pr-2.5 tw-rounded-full tw-border tw-border-solid tw-text-13 tw-font-semibold tw-whitespace-nowrap ${PILL_CLASSES[statusKey]}`}
        >
            <span className={`tw-w-2 tw-h-2 tw-rounded-full tw-flex-shrink-0 ${DOT_CLASSES[statusKey]}`} aria-hidden />
            {label}
        </span>
    );
}

StatusChip.propTypes = {
    statusKey: PropTypes.oneOf(['active', 'passive', 'closed', 'unknown']).isRequired,
    locale: PropTypes.string,
    rawLabel: PropTypes.string,
};

StatusChip.defaultProps = {
    locale: 'sq',
    rawLabel: '',
};
